// Public event-category resolution. Used to mark which Polymarket
// events belong to a "public" category for breadcrumbs, SEO, and
// route prefixes. Whitelisted set is closed — anything outside it
// resolves to null and the caller falls back to a generic category.

export const PUBLIC_EVENT_CATEGORIES = new Set([
  "politics",
  "sports",
  "crypto",
  "economy",
  "economics",
  "finance",
  "tech",
  "technology",
  "science",
  "entertainment",
  "world",
  "us",
  "elections",
  "culture",
  "climate",
  "health",
  "business",
  "gaming",
  "music",
  "ai",
  "geopolitics",
  "weather",
  "financials",
  "energy",
]);

/**
 * Resolve the canonical public-category label for an event. If
 * `preferred` is in the whitelist it wins; otherwise the first
 * matching tag does. Tag entries can be strings or `{ label, slug,
 * name }` shapes (Polymarket / Kalshi differ here).
 */
export function getPublicEventCategory(
  tags: any[] | null | undefined,
  preferred?: string | null | undefined,
): string | null {
  const normalizedPreferred = typeof preferred === "string" ? preferred.trim().toLowerCase() : null;
  if (normalizedPreferred && PUBLIC_EVENT_CATEGORIES.has(normalizedPreferred)) {
    return preferred!.trim();
  }

  if (!Array.isArray(tags)) return null;

  const match = tags
    .map((tag) => typeof tag === "string" ? tag : (tag?.label || tag?.slug || tag?.name || ""))
    .find((label) => {
      const normalized = String(label).trim().toLowerCase();
      return normalized && PUBLIC_EVENT_CATEGORIES.has(normalized);
    });

  return match ? String(match).trim() : null;
}
